import React from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import GeetDirection from '../../get-direction/getdirection';
import './contactus.css';
import axios from '../../axios';


class Contactus extends React.Component {

    constructor(props){
         super(props);
         this.state = {
           name :'',
           email:'',
           message : '',
           construction: "",
           plots : "",
           plans : "",
           others : "",
           isLoading : false,
           isSended : false,
           isError:false,

         }

         this.changeHandler = this.changeHandler.bind(this);
         this.submitHandler = this.submitHandler.bind(this);

    }

      changeHandler = (e) => {
          let name = e.target.name;
          let value = e.target.value;

          this.setState({
            [name] : value
          })
      }

      submitHandler = async (e) => {
           e.preventDefault();
           this.setState({isLoading:true})
            // console.log(this.state.construction,this.state.email,this.state.message,this.state.name, this.state.plans, this.state.plots);
       
            if(!this.state.name && !this.state.email && !this.state.message && !this.state.plans && !this.state.plots && !this.state.construction && !this.state.others){
                      this.setState({construction:'general purpose'})
            }

            let formData = {
              name : this.state.name,
              email :  this.state.email,
              message : this.state.message,
              services : {
                  construction : this.state.construction,
                  plans : this.state.plans,
                  plots : this.state.plots,
                  others : this.state.others
              }
            }
  
       axios.post("`https://cors-anywhere.herokuapp.com/https://sps-land-promoters.herokuapp.com/api/email",{formData})
       .then(res => {
        //  console.log(res)
         this.setState({isLoading:false});
         this.setState({isSended:true});

       setTimeout(()=>{
         this.setState({isSended:false})
       },5000)
      }
       )
       .catch(error =>{ console.log(error)
        this.setState({isLoading:false})
        this.setState({isError:true})
        setTimeout(()=>{
          this.setState({isError:false})
        },5000)
      })
      }
   render(){
    return(
        <div className='contactus_page'>
      <Heading />
        <h3 className="contactus_heading">Contact Us</h3>
        <div className="contactus_container">
            <form className="contact_us_form_container"  onSubmit={this.submitHandler}>

            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" className="form-control" name="name" id="name" aria-describedby="helpId"
               onChange={this.changeHandler}
              placeholder="Name"
               autoComplete="false"
                required
               />
              
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" className="form-control" name="email" id="email" aria-describedby="emailHelpId" placeholder="Enter your email" autoComplete="false" 
              onChange={this.changeHandler}
             required
             />

              
            </div>
               <p>Select service <span style={{color:'gray',marginTop:'10px'}}>(optional)</span></p>
            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input" 
                onChange={this.changeHandler}
                name="plots" id="plots" value="plots and approvals" />
                Plots &#38; Approvals
              </label>
              
            </div>

            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input"
                onChange={this.changeHandler}
                name="construction" id="construction" value="construction and road work" />
                construction &#38; Road Work
              </label>
              
            </div>

            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input" 
                onChange={this.changeHandler}
                name="plans" id="plans" value="2d and 3d plans" />
                2D &#38; 3D plans
              </label>
              
            </div>


            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input"
                onChange={this.changeHandler}
                name="others" id="others" value="other service" />
               Others
              </label>
              
            </div>

            <div className="form-group">
              <label htmlFor="message">Message :</label> 
              <textarea className="form-control" name="message"
                onChange={this.changeHandler}
                id="message" rows="5"
                required
                placeholder='Say Hi'></textarea>

            </div>
            <button className='btn btn-primary text-center mt-4' disabled={this.state.isLoading}>{this.state.isLoading ? "Sending.." : "Submit"}</button>
             <p style={{color:'red'}}>{this.state.isError ? "your message cannot send, please contact other way..":""}</p>
             <p style={{color:'green'}}>{this.state.isSended ? "your message received..":""}</p>
            </form>
              
              <div className="contact_google_map_container">
      <h3 className='get_direction_heading' >Get Direction</h3> 
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3392.235592344331!2d77.44596580266187!3d9.978188749361927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0713c66be4302b%3A0xbc5ea57c0c239fae!2ssps%20land%20promoters!5e1!3m2!1sen!2sin!4v1646663417908!5m2!1sen!2sin" className="contact_google_map" allowfullscreen='true' loading="lazy"></iframe>
    </div>
        </div>
      <Footer />
        </div>
    )
}
}

export default Contactus